/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TransactionDetailDto } from './transactionDetailDto';


export interface TransactionDetailDtoPagedResultDto { 
    items?: Array<TransactionDetailDto> | null;
    totalCount?: number;
}

